import eventsNSFWNames from '../events/nsfw';
import { useSendEvent } from '../useSendEvent';

const useSafeModeSwitched = () =>
	useSendEvent(eventsNSFWNames.safeModeSwitched, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const annalsNsfw = {
	useSafeModeSwitched,
};

export default annalsNsfw;
